import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Input } from './ui/input';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CreateBusinessDialog = ({ open, onClose, onCreated }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [saving, setSaving] = useState(false);

  const create = async () => {
    setSaving(true);
    try {
      const res = await axios.post(`${API}/auth/my-business`, { business_name: name, phone: phone || null });
      onCreated(res.data.business_id);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not create your business');
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white text-slate-900 border-slate-200 sm:max-w-md" data-testid="create-business-dialog">
        <DialogHeader>
          <DialogTitle className="text-slate-900">Tell us about your business</DialogTitle>
          <DialogDescription className="text-slate-500">We'll set up your dashboard, then you can finish phone setup and pay.</DialogDescription>
        </DialogHeader>
        <Input placeholder="Business name" value={name} onChange={(e) => setName(e.target.value)} className="bg-white border-slate-300 text-slate-900" data-testid="create-business-name" />
        <Input type="tel" placeholder="Your cell phone (optional)" value={phone} onChange={(e) => setPhone(e.target.value)} className="bg-white border-slate-300 text-slate-900" data-testid="create-business-phone" />
        <Button onClick={create} disabled={!name.trim() || saving} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="create-business-submit">
          {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Continue
        </Button>
      </DialogContent>
    </Dialog>
  );
};
